import { TABLA_REPORTE_EMBARQUE_SECTOR_4 } from '../../../../../config/tables'
import { COLUMNS_REPORTE_EMBARQUE_SECTOR_4_TO_PRINT, COLUMNS_REPORTE_EMBARQUE_SECTOR_4 } from './constantesReporteEmbarqueSector4'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import { ReporteEmbarqueSector4Service } from '../../../../../models/movimiento/ReporteEmbarquePorSector/tabla_reporte_embarque_sector_4'

export function actualizarDatosParaMuiTable (cereal, cerealVariedad, etiqueta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_REPORTE_EMBARQUE_SECTOR_4
    })
    const promiseReporteEmbarqueSector4 = ReporteEmbarqueSector4Service.getDataReporteEmbarqueSector4(cereal, cerealVariedad, etiqueta)
    const promiseReporteEmbarqueSector4Total = ReporteEmbarqueSector4Service.getDataReporteEmbarqueSector4Total(cereal, cerealVariedad, etiqueta)
    Promise.all([promiseReporteEmbarqueSector4, promiseReporteEmbarqueSector4Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = (dataArray[1] || [])[0] || {}
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Reporte Embarque Sector 4',
        dataCombinada,
        COLUMNS_REPORTE_EMBARQUE_SECTOR_4_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_REPORTE_EMBARQUE_SECTOR_4,
          data: dataCombinada,
          title: `Reporte Embarque Sector 4`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false }
        },
        id: TABLA_REPORTE_EMBARQUE_SECTOR_4
      })
    }
  }
}
